import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/inbox',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:86
* @route '/app/inbox'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
export const show = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/inbox/{lead}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
show.url = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { lead: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { lead: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            lead: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        lead: typeof args.lead === 'object'
        ? args.lead.id
        : args.lead,
    }

    return show.definition.url
            .replace('{lead}', parsedArgs.lead.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
show.get = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
show.head = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
const showForm = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
showForm.get = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:172
* @route '/app/inbox/{lead}'
*/
showForm.head = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\LeadController::update
* @see app/Http/Controllers/Admin/LeadController.php:197
* @route '/app/inbox/{lead}'
*/
export const update = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/app/inbox/{lead}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::update
* @see app/Http/Controllers/Admin/LeadController.php:197
* @route '/app/inbox/{lead}'
*/
update.url = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { lead: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { lead: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            lead: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        lead: typeof args.lead === 'object'
        ? args.lead.id
        : args.lead,
    }

    return update.definition.url
            .replace('{lead}', parsedArgs.lead.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::update
* @see app/Http/Controllers/Admin/LeadController.php:197
* @route '/app/inbox/{lead}'
*/
update.patch = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::update
* @see app/Http/Controllers/Admin/LeadController.php:197
* @route '/app/inbox/{lead}'
*/
const updateForm = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::update
* @see app/Http/Controllers/Admin/LeadController.php:197
* @route '/app/inbox/{lead}'
*/
updateForm.patch = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/LeadController.php:226
* @route '/app/inbox/bulk-destroy'
*/
export const bulkDestroy = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDestroy.url(options),
    method: 'post',
})

bulkDestroy.definition = {
    methods: ["post"],
    url: '/app/inbox/bulk-destroy',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/LeadController.php:226
* @route '/app/inbox/bulk-destroy'
*/
bulkDestroy.url = (options?: RouteQueryOptions) => {
    return bulkDestroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/LeadController.php:226
* @route '/app/inbox/bulk-destroy'
*/
bulkDestroy.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDestroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/LeadController.php:226
* @route '/app/inbox/bulk-destroy'
*/
const bulkDestroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDestroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/LeadController.php:226
* @route '/app/inbox/bulk-destroy'
*/
bulkDestroyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDestroy.url(options),
    method: 'post',
})

bulkDestroy.form = bulkDestroyForm

/**
* @see \App\Http\Controllers\Admin\LeadController::destroy
* @see app/Http/Controllers/Admin/LeadController.php:209
* @route '/app/inbox/{lead}'
*/
export const destroy = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/inbox/{lead}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::destroy
* @see app/Http/Controllers/Admin/LeadController.php:209
* @route '/app/inbox/{lead}'
*/
destroy.url = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { lead: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { lead: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            lead: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        lead: typeof args.lead === 'object'
        ? args.lead.id
        : args.lead,
    }

    return destroy.definition.url
            .replace('{lead}', parsedArgs.lead.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::destroy
* @see app/Http/Controllers/Admin/LeadController.php:209
* @route '/app/inbox/{lead}'
*/
destroy.delete = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::destroy
* @see app/Http/Controllers/Admin/LeadController.php:209
* @route '/app/inbox/{lead}'
*/
const destroyForm = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::destroy
* @see app/Http/Controllers/Admin/LeadController.php:209
* @route '/app/inbox/{lead}'
*/
destroyForm.delete = (args: { lead: string | { id: string } } | [lead: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const inbox = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    bulkDestroy: Object.assign(bulkDestroy, bulkDestroy),
    destroy: Object.assign(destroy, destroy),
}

export default inbox